(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_flexi-layout-slider"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  function initBlazeSliders(target = document) {
    target.querySelectorAll('.flexi-blaze-slider').forEach((el) => {
      const parent = el.parentNode;
      const clone = el.cloneNode(true);
      parent.replaceChild(clone, el);

      const desktopSlides = parseFloat(clone.dataset.blazeDesktop) || 4;
      const tabletSlides = parseFloat(clone.dataset.blazeTablet) || 2.2;
      const mobileSlides = parseFloat(clone.dataset.blazeMobile) || 1.2;
      const loop = clone.dataset.blazeLoop === 'true';
      const draggable = clone.dataset.blazeDraggable === 'true';
      const autoplay = clone.dataset.blazeAutoplay === 'true';
      const autoplayDuration = parseFloat(clone.dataset.blazeAutoplayDuration) || 2000;
      const autoplayPause = clone.dataset.blazeAutoplayPause === 'true';

      new BlazeSlider(clone, {
        all: {
          slidesToShow: desktopSlides,
          slidesToScroll: 1,
          transitionDuration: 200,
          loop: loop,
          draggable: draggable,
          autoplayInterval: autoplayDuration,
          enableAutoplay: autoplay,
          stopAutoplayOnInteraction: autoplayPause,
          prevArrow: el.querySelector('.blaze-prev'), 
          nextArrow: el.querySelector('.blaze-next'), 
        },
        '(max-width: 900px)': {
          slidesToShow: tabletSlides,
        },
        '(max-width: 500px)': {
          slidesToShow: mobileSlides,
        },
      });
    });
  }

  initBlazeSliders();

  document.addEventListener('shopify:section:load', function (event) {
    initBlazeSliders(event.target);
  });

  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      initBlazeSliders();
    }, 300);
  });
});
  } catch(e) { console.error(e); }
})();

})();
